import { render, staticRenderFns } from "./WebPagesHeroBlockForm.vue?vue&type=template&id=6da541f2&"
import script from "./WebPagesHeroBlockForm.vue?vue&type=script&lang=js&"
export * from "./WebPagesHeroBlockForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports